Browser = require 'lib/browser'
Dates = require 'lib/dates'
DueDateHelpers = require 'views/internal/due-date-helpers'
Label = require 'models/label'
PluginModelSerializer = require 'views/internal/plugins/plugin-model-serializer'
PluginRunner = require 'views/internal/plugins/plugin-runner'
templates = require 'views/internal/templates'
_ = require 'underscore'
labelTemplate = require 'views/templates/label'
pluginCoverWithDefaults = require 'lib/plugins/plugin-cover-with-defaults'
pluginValidators = require 'lib/plugins/plugin-validators'
t = require('views/internal/teacup-with-helpers')('badge')
l = require 'lib/localize'
simpleTest = require 'lib/experiments/simple-test'

badgesTemplate = t.renderable ({
  archived
  attachments
  attachmentsByType
  checkItems
  checkItemsChecked
  comments
  description
  due
  dueComplete
  notifications
  subscribed
  viewingMemberVoted
  votes
}) ->
  if notifications
    t.div '.badge.is-unread-notification', { title: l('badge.notifications') }, ->
      t.span '.badge-icon.icon-sm.icon-notification'
      t.span '.badge-text', ->
        t.text notifications
  # Experiment: subscribeToWatchOrFollow
  if subscribed
    subscribeToWatchOrFollow = simpleTest 'subscribeToWatchOrFollow'
    subscribeString = 'subscribed'
    if subscribeToWatchOrFollow?.inExperiment and subscribeToWatchOrFollow.get('variation') != 'control'
      subscribeString = subscribeToWatchOrFollow.get('variation')

    t.div '.badge.is-icon-only', { title: l("badge.#{subscribeString}") }, ->
      t.span '.badge-icon.icon-sm.icon-subscribe'

  if votes > 0
    t.div '.badge', { title: l('badge.votes'), class: t.classify('is-voted': viewingMemberVoted) }, ->
      t.span '.badge-icon.icon-sm.icon-vote'
      t.span '.badge-text', ->
        t.text votes

  if due
    t.div '.badge', { title: DueDateHelpers.titleForDueDate(due, dueComplete), class: DueDateHelpers.classForDueDate(due, dueComplete) }, ->
      t.span '.badge-icon.icon-sm.icon-clock'
      t.span '.badge-text', ->
        t.text Dates.toDateString(due)

  if description
    t.div '.badge.is-icon-only', { title: l('badge.description') }, ->
      t.span '.badge-icon.icon-sm.icon-description'

  if comments > 0
    t.div '.badge', { title: l('badge.comments') }, ->
      t.span '.badge-icon.icon-sm.icon-comment'
      t.span '.badge-text', ->
        t.text comments

  trelloAttachments = if attachmentsByType
    attachmentsByType.trello.board + attachmentsByType.trello.card
  else
    0

  attachments = attachments - trelloAttachments
  if attachments > 0
    t.div '.badge', { title: l('badge.attachments') }, ->
      t.span '.badge-icon.icon-sm.icon-attachment'
      t.span '.badge-text', ->
        t.text attachments

  if trelloAttachments > 0
    t.div '.badge', { title: l('badge.trello attachments') }, ->
      t.span '.badge-icon.icon-sm.icon-board'
      t.span '.badge-text', ->
        t.text trelloAttachments

  if checkItems > 0
    t.div '.badge', { title: l('badge.checkitems'), class: t.classify('is-complete': checkItemsChecked == checkItems) }, ->
      t.span '.badge-icon.icon-sm.icon-checklist'
      t.span '.badge-text', ->
        t.text checkItemsChecked
        t.text "/"
        t.text checkItems

  if archived
    t.div '.badge', { title: l('badge.archived.title') }, ->
      t.span '.badge-icon.icon-sm.icon-archive'
      t.span '.badge-text', ->
        t.text l('badge.archived.text')


# This whole file shouldn't exist. It only exists because the *previous*
# way that the QuickCardEditor was implemented was even worse. But I'm not
# going to fight that fight today. This is me taking the easy way out.

module.exports =
  renderCover: ->
    clearCover = =>
      @$el.removeClass('is-covered')
      @$('.js-card-stickers').css('height', '')
      @$('.js-card-cover')
      .css
        'background-origin': ''
        'background-image': ''
        'background-color': ''
        'height': ''
        'padding': ''
      .removeClass('is-no-preview-size')

    if !@model.getBoard().getPref('cardCovers') || @onCalendar
      # card covers are disabled on the board or user is on calendar
      clearCover()
      return @

    attachmentCover = @model.attachmentList.get(@model.get('idAttachmentCover'))

    if attachmentCover?
      minWidth = if Browser.isHighDPI() then 600 else 300
      preview =
        attachmentCover.smallestPreviewBiggerThan(minWidth) ?
        attachmentCover.biggestPreview()

      if preview?
        coverImgSrc = preview.url
      else
        coverImgSrc = attachmentCover.get('url')

      $cardCover = @$('.js-card-cover')
      $cardCover
        .css
          'background-color': attachmentCover.get('edgeColor') ? 'transparent'
          'background-image': "url(\"#{coverImgSrc}\")"
        .toggleClass('is-no-preview-size', !preview?)

      if preview?
        $cardStickers = @$('.js-card-stickers')

        maxHeight = Math.min(preview.height, 260) # An arbitrarily chosen number

        # 245 is the effective width of the card (including padding and margin
        # and scrollbars)
        calculatedHeight = preview.height * 245 / preview.width
        if calculatedHeight <= maxHeight
          $cardCover
            .css({
              height: calculatedHeight
              'background-size': 'cover'
            })
          $cardStickers.css('height', calculatedHeight)
        else
          $cardCover.css({
            height: maxHeight,
            'background-size': 'contain'
          })
          $cardStickers.css('height', maxHeight)
      @$el.addClass('is-covered')
    else
      # card doesn't (or no longer) has a native cover
      @waitForId @model, =>
        PluginRunner.one
          command: 'card-cover'
          board: @model.getBoard()
          card: @model
          list: @model.getList()
          timeout: 10000
          options:
            attachments: PluginModelSerializer.attachments(@model.attachmentList.models, ['id', 'url'])
            cardDetail: false
        .then (pluginCover) =>
          # to avoid race conditions since this was async, check if there is
          # a native cover again
          if @model.hasCover()
            return
          if !pluginValidators.isValidCover(pluginCover)
            throw new Error('Invalid cover supplied')
          sanitizedCover = pluginCoverWithDefaults(pluginCover)
          # update the CSS
          $cardCover = @$('.js-card-cover')
          $cardCover
            .css
              'background-origin': 'content-box'
              'background-color': sanitizedCover.edgeColor
              'background-image': "url(\"#{sanitizedCover.url}\")"
              'background-position': sanitizedCover.position
              'background-repeat': 'no-repeat'
              'background-size': sanitizedCover.size
              'height': "#{sanitizedCover.height}px"
              'padding': sanitizedCover.padding
            .removeClass('is-no-preview-size')
          @$('.js-card-stickers').css('height', sanitizedCover.stickerHeight)
          @$el.addClass('is-covered')
        .catch =>
          # to avoid race conditions since this was async, check if there is
          # a native cover again
          if !@model.hasCover()
            clearCover()

    @

  getBadgesHtml: ->
    badges = @model.get('badges') ? {}

    badgesTemplate({
      subscribed: badges.subscribed
      description: badges.description
      comments: badges.comments
      attachments: badges.attachments
      attachmentsByType: badges.attachmentsByType
      checkItems: badges.checkItems
      checkItemsChecked: badges.checkItemsChecked
      votes: badges.votes
      viewingMemberVoted: badges.viewingMemberVoted
      due: @model.get('due')
      dueComplete: @model.get('dueComplete')
      notifications:
        _.filter @modelCache.all('Notification'), (notification) =>
          notification.get('unread') &&
          @model.id? &&
          notification.get('data')?.card?.id == @model.id
        .length
      archived: @model.get('closed')
    })

  renderBadges: ->
    badges = @model.get('badges') ? {}

    @el.querySelector('.js-badges').innerHTML = @getBadgesHtml()
    @

  renderMembers: (e) ->
    html = ""
    org = @model.getBoard().getOrganization()
    memberHtmls = for member in @model.memberList.models by -1
      @getMemberOnCardHtml member
    @$('.js-list-card-members').empty().append memberHtmls.join('')
    @

  labelsData: ->
    _.chain(@model.getLabels())
      .sort(Label.compare)
      .map (label) => @model.dataForLabel(label)
      .filter (uiLabel) -> !_.isEmpty(uiLabel.color)
      .value()

  renderLabels: ->
    labelsHtml = for label in @labelsData()
      data = label
      data.extraClasses = ['mod-card-front']
      labelTemplate(data)

    @$('.js-card-labels').empty().append(labelsHtml)
    @



// WEBPACK FOOTER //
// ./app/scripts/views/card/card-view-mixins.coffee